import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon, IdCardIcon } from 'lucide-react';
const credentials = ['Résident', 'Piscine', 'Activité inscrite', 'Accès installation', 'Réservation'];
export function CardAccess() {
  return <section aria-labelledby="carte-acces-titre" className="mt-14 grid gap-6 rounded-3xl border border-slate-200 bg-white p-6 sm:p-8 lg:grid-cols-[minmax(0,1fr)_minmax(0,320px)] lg:items-center" data-id="element-1833" data-mp="b09mknh9w2qs">
      <div data-id="element-1834" data-mp="11tvgki8wtha">
        <h2 id="carte-acces-titre" className="text-2xl font-extrabold tracking-tight text-ville-navy" data-id="element-1835" data-mp="3t7qmqh1x5qyr">
          Ma carte numérique
        </h2>
        <p className="mt-2 max-w-xl text-[15px] leading-relaxed text-slate-600" data-id="element-1836" data-mp="3o9p7k77m6bsk">
          Votre carte vous permet d’accéder à vos activités et installations participantes. Aucune autre carte de
          loisirs n’est nécessaire.
        </p>
        <ul className="mt-4 flex flex-wrap gap-2" data-id="element-1837" data-mp="1mewxp85osb8t">
          {credentials.map(credential => <li key={credential} className="rounded-full bg-slate-100 px-3 py-1 text-xs font-bold text-ville-navy" data-id="element-1838" data-mp="1hgd9f13menda">
              {credential}
            </li>)}
        </ul>
        <Link to="/ma-carte" className="mt-6 inline-flex items-center gap-2 text-sm font-bold text-ville-indigo hover:underline focus:outline-none focus-visible:ring-2 focus-visible:ring-ville-indigo" data-id="element-1839" data-mp="1d56znvji4zou">
          Voir ma carte
          <ArrowRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-1840" data-mp="25ue4fc9julij" />
        </Link>
      </div>

      <div className="rounded-2xl bg-ville-navy p-5 text-white" data-id="element-1841" data-mp="2arw5yhl8lygi">
        <div className="flex items-center justify-between" data-id="element-1842" data-mp="1w4kuefp22ege">
          <span className="flex items-center gap-2 text-xs font-bold uppercase tracking-[0.14em]" data-id="element-1843" data-mp="1w1ylabminqw2">
            <IdCardIcon className="h-4 w-4 text-ville-lime" aria-hidden="true" data-id="element-1844" data-mp="2osgpjfyz7yb2" />
            Carte numérique
          </span>
          <span className="text-xs font-semibold text-white/60" data-id="element-1845" data-mp="2tjp1ojroxxrx">Brossard</span>
        </div>
        <p className="mt-6 text-lg font-extrabold" data-id="element-1846" data-mp="33excxs4xja7b">Charlotte Bouchard</p>
        <p className="font-mono text-sm tracking-[0.2em] text-white/70" data-id="element-1847" data-mp="33ct91a716b71">•••• •••• 4127</p>
      </div>
    </section>;
}